// End the visit (host) — direct fetch (the published api-client has no `end` method yet; SDK is
// single-owner). Flips the visit live → completed; normally the Zoom webhook does this, but it's not
// wired for the demo. Auth is the dev-session cookie (credentials:include).
import { API_ORIGIN } from "../config";

export async function endVisit(id: string): Promise<void> {
  const res = await fetch(`${API_ORIGIN}/v1/doctor/visits/${id}/end`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) throw new Error(`end failed (${res.status})`);
}
